import templateUrl from './regulator-add-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    regulator: '<',
    dialogTitle: '@',
    submitTitle: '@',
    onRegulatorChanged: '&'
  },
  controller: class RegulatorAddFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onRegulatorChanged(
        this.EventEmitter({
          regulator: this.regulator
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-add-form/regulator-add-form.component.js